
import Vue from "vue";

export default Vue.extend({
  name: "MenuIcon",
  data() {
    return {
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
    };
  },
});
